module.exports = __webpack_public_path__ + "img/IMG_9512_L_WoodMatted_MockedUp.e9e234c8.jpg";